<template>
 <div class="main">
  <ImageCropper v-on:croppedImg="onCroppedImg" v-bind:img="editableImage" v-if="editableImage"></ImageCropper>
 </div>
</template>

<script>
import ImageCropper from '../components/ImageCropperNew';
import memoryStore from '../stores/MemoryStore';
import { eventBus } from '../services/EventBus';
import userService from '../services/User.service';
import store from '../stores';
import RestStore from '../stores/RestStore';
const restStore = new RestStore();
export default {
  name: 'EditImage',
  components: {
    ImageCropper
  },
  data() {
    return {
      editableImage: null
    };
  },
  mounted() {
    this.editableImage = memoryStore.editableImage;
  },
  methods: {
    onCroppedImg(cropImg) {
      const filename =
        userService.user.name.toLowerCase().replace(/\s+/g, '') +
        new Date().getTime() +
        '.png';
      console.log('filename', filename);

      eventBus.$emit('updating');
      restStore
        .getUploadUrl(cropImg, 'image/png', filename)
        .then(response => response.json())
        .then(resp => {
          console.log(resp.url);
          const param =
            Math.random()
              .toString(36)
              .substring(2, 15) +
            Math.random()
              .toString(36)
              .substring(2, 15);
          userService.user.photos[0] = `https://rds-life-dev-templates.s3-eu-west-1.amazonaws.com/usersImg/${filename}?v=${param}`;
          restStore.uploadFile(resp.url, 'image/png', cropImg);
        })
        .then(() => {
          store
            .update('rdsUser', userService.user.id, userService.user)
            .then(u => {
              wait(1000).then(() => {
                userService.user = u;
                eventBus.$emit('updated');
                this.$router.push('/');
                this.editImageMode = false;
                if (!!memoryStore.editableImage) {
                  delete memoryStore.editableImage;
                }
              });
            })
            .catch(e => {
              console.warn(e);
              eventBus.$emit('updated');
              this.editImageMode = false;
              if (!!memoryStore.editableImage) {
                delete memoryStore.editableImage;
              }
            });
        })
        .catch(e => {
          console.warn(e);
          eventBus.$emit('updated');
          this.editImageMode = false;
        });

      // eventBus.$emit('updating');
      // store
      //   .update('rdsUser', this.currentUser.id, this.currentUser)
      //   .then(u => {
      //     userService.user = u;
      //     eventBus.$emit('updated');
      //     this.editImageMode = false;
      //   })
      //   .catch(e => {
      //     console.warn(e);
      //     eventBus.$emit('updated');
      //     this.editImageMode = false;
      //   });
    }
  }
};
function wait(milliseconds) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, milliseconds);
  });
}
</script>

<style scoped></style>
